/**!*******************************************************************
 *
 * Copyright (c) Epic AI GmbH. All rights reserved.
 * Author:  Alexander Claas
 *
 ********************************************************************!*/

import { MutationTree } from "vuex";
import { IUserState } from "./state";
import { User } from "firebase/auth";

export enum Mutations {
  SIGN_IN = "SIGN_IN",
  SET_ID_TOKEN = "SET_ID_TOKEN",
  SET_ORGANIZATION = "SET_ORGANIZATION",
  SIGN_OUT = "SIGN_OUT",
}

export interface IMutations<S = IUserState> {
  [Mutations.SIGN_IN](state: S, payload: User): void;
  [Mutations.SET_ID_TOKEN](state: S, payload: string): void;
  [Mutations.SET_ORGANIZATION](state: S, orgId: string): void;
  [Mutations.SIGN_OUT](state: S): void;
}

export const mutations: MutationTree<IUserState> & IMutations = {
  [Mutations.SIGN_IN]: (state: IUserState, user: User) => {
    state.user = user;
    state.signedIn = true;
  },
  [Mutations.SET_ID_TOKEN]: (state: IUserState, idToken: string) => {
    state.idToken = idToken;
  },
  [Mutations.SET_ORGANIZATION]: (state: IUserState, orgId: string) => {
    state.organization = {
      id: orgId,
      name: orgId,
    };
  },
  [Mutations.SIGN_OUT]: (state: IUserState) => {
    state = {
      user: {} as User,
      idToken: "",
      signedIn: false,
    };
  },
};
